module.exports = __webpack_public_path__ + "static/media/icon-coin-clients-top.fc53c318.png";